/*****************统计管理*****************/
export default [{
    path: "/transaction",
    name: "交易分析"
  },
  {
    path: "/flow",
    name: "流量分析"
  },
  {
    path: "/goodsAnalysis",
    name: "商品分析"
  },
  {
    path: "/memberAnalysis",
    name: "会员分析"
  }
]
